import baseStyled, { css as baseCss, ThemedCssFunction, ThemedStyledInterface } from 'styled-components';

import { EquipmentMasterTheme } from './themes/types';

const styled = baseStyled as ThemedStyledInterface<EquipmentMasterTheme>;
const css = baseCss as ThemedCssFunction<EquipmentMasterTheme>;

export const EquipmentMaster = styled.div`
  width: 100%;
  height: 100%;
`;
